import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Search, Clock, MessageSquare } from 'lucide-react';
export const ProblemAgitation = () => {
  return <section className="w-full bg-[#FFF9F3] py-16 px-4 md:py-24" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        {/* Not a Diagnosis Disclaimer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 rounded-2xl shadow-sm mb-16 border border-[#1B2A4A]/5" data-id="element-126">
          <div className="flex items-start space-x-4" data-id="element-127">
            <AlertCircle className="w-6 h-6 text-[#E8734A] flex-shrink-0 mt-1" data-id="element-128" />
            <div data-id="element-129">
              <h3 className="text-xl font-bold text-[#1B2A4A] mb-2" data-id="element-130">
                Esto NO es un diagnóstico
              </h3>
              <p className="text-[#2D3436] leading-relaxed" data-id="element-131">
                Empecemos por lo obvio (porque internet no lo hace): Una guía no
                puede diagnosticar. Y esta guía no lo intenta. Lo que sí puede
                hacer —y lo que tú necesitas ahora— es darte{' '}
                <span className="font-bold bg-[#2ABFBF]/20 px-1" data-id="element-132">
                  claridad accionable
                </span>
                .
              </p>
            </div>
          </div>
        </motion.div>

        <div className="text-center mb-12" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B2A4A] mb-4" data-id="element-134">
            Por qué lo que has intentado falla
          </h2>
          <p className="text-lg text-[#2D3436]/80 max-w-2xl mx-auto" data-id="element-135">
            No es tu culpa. El sistema y el internet no están diseñados para
            darte paz mental.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-136">
          {[{
          icon: Search,
          title: 'Google te da volumen, no prioridad',
          desc: 'Te enseña 50 “señales” como si todas pesaran igual. No pesan igual. Terminas más confundido que al principio.'
        }, {
          icon: MessageSquare,
          title: 'Redes sociales te dan emociones, no decisiones',
          desc: 'Te dejan pensando “esto se parece” o “esto no se parece”… pero no te dan un plan concreto.'
        }, {
          icon: Clock,
          title: '“Espera y verás” calma a otros, pero no a ti',
          desc: 'Porque tú no quieres una opinión vaga. Quieres una estructura y saber qué hacer hoy.'
        }].map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-137">
              <div className="w-12 h-12 bg-[#1B2A4A]/5 rounded-full flex items-center justify-center mb-4 text-[#1B2A4A]" data-id="element-138">
                <item.icon className="w-6 h-6" data-id="element-139" />
              </div>
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-3" data-id="element-140">
                {item.title}
              </h3>
              <p className="text-[#2D3436] text-sm leading-relaxed" data-id="element-141">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};